<template>
    <div
        class="supsis-button"
        :class="{ [classNames]: true, disabled, primary, danger, ghost, small, xsmall, xxsmall, large, xlarge, block }"
        @click="click"
        :id="id"
    >
        <slot />
    </div>
</template>

<script>
export default {
    name: "SupsisButton",
    props: {
        classNames: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        primary: {
            type: Boolean,
            default: false,
        },
        danger: {
            type: Boolean,
            default: false,
        },
        ghost: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        xsmall: {
            type: Boolean,
            default: false,
        },
        xxsmall: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        xlarge: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
        },
        icon: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        click(event) {
            if (this.disabled) {
                return;
            }
            this.$emit("click", event);
        },
    },
};
</script>

<style scoped lang="scss">
.supsis-button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    max-width: fit-content;
    height: 35px;
    border-radius: 5px;
    cursor: pointer;
    gap: 4px;
    padding: 5px 10px;

    border: 1px solid var(--color-bg-neutral-default);
    background-color: var(--color-bg-neutral-default);
    color: var(--color-text-default);

    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    pointer-events: all;

    &.icon {
        padding: 0;
        border: none;
        background-color: transparent;
    }

    &.small {
        min-width: 32px;
    }

    &.xsmall {
        min-width: 24px;
    }

    &.xxsmall {
        min-width: 16px;
    }

    &.large {
        padding: 20px 30px;
    }

    &.xlarge {
        padding: 30px 50px;
    }

    &.block {
        width: 100%;
        max-width: unset;
        justify-content: center;
        align-items: center;
    }

    &:hover {
        opacity: 0.8;
    }

    &.primary {
        border: 1px solid #22272d;
        background-color: #22272d;
        color: var(--color-text-onprimary-default);
    }

    &.danger {
        border: 1px solid var(--color-border-critical-default);
        background-color: var(--color-bg-critical-default);
        color: var(--color-text-onprimary-default);
    }

    &.supsis-base {
        border: 1px solid rgb(236, 75, 29);
        background-color: rgb(236, 75, 29);
        color: var(--color-text-onprimary-default);

        &:hover {
            opacity: 0.8;
        }
    }

    &.primary:hover {
        opacity: 0.8;
    }

    &.ghost {
        border: 1px solid #22272d;
        background-color: transparent;
        color: var(--default-text-color);
    }

    &:active {
        opacity: 0.8;
    }

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}
</style>
